// extracted by mini-css-extract-plugin
module.exports = {"contentTabs":"ZGkdtX","tabs":"aIsziI","dropdownContainer":"uGRIY3","item":"_96e6_k"};